import React, { useState, useEffect } from "react";
import BusinessInfoForm from "./BusinessInfoForm";
import { emailMasking } from "../../../../util/CommonReadonlyMasking";
import { MonitoringData } from "../../../../store/common";
import { ApplicationState } from "../../../../store";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

const BusinessInfo: React.FunctionComponent<{ monitoringData: MonitoringData; ensureDataFetch: any }> = (props) => {
    const [addressInfo, setAddressInfo] = useState({});
    const [personalInfo, setPersonalInfo] = useState(false);
    const [isLoading, setisLoading] = useState(false);
    const [monitoringData, setMonitoringData] = useState(props.monitoringData);
    const businessProfileStatus = useSelector(
        (state: ApplicationState) =>
            state.loggedInUser &&
            state.loggedInUser.userServiceDetails?.businessProfileStatus?.filter((obj: any) => {
                return obj.provider;
            })
    );
    const creditProvider = businessProfileStatus != null && businessProfileStatus.length > 0 ? businessProfileStatus[0].provider : "";
    const { t: tLang } = useTranslation();

    const ensureDataFetched = () => {
        setisLoading(true);
        props.ensureDataFetch();
    };

    useEffect(() => {
        const personalInformation = props.monitoringData.asset["personalInformation"];
        const addressInformation = props.monitoringData.asset["addressInformation"];
        setAddressInfo(addressInformation);
        setFormData({
            "ezshield-id": monitoringData.asset && monitoringData.asset["ezshield-id"],
            "idf-user-id": monitoringData.asset && monitoringData.asset["idf-user-id"],
            "date-of-birth": personalInformation && personalInformation["date-of-birth"] && personalInformation["date-of-birth"],
            emails: personalInformation
                ? personalInformation["additional-emails-address"]
                    ? [personalInformation["primary-email-address"], ...personalInformation["additional-emails-address"]]
                    : personalInformation["primary-email-address"]
                    ? [personalInformation["primary-email-address"]]
                    : [{ email: "" }]
                : [{ email: "" }],
            firstName: personalInformation ? personalInformation["first-name"] : "",
            lastName: personalInformation ? personalInformation["last-name"] : "",
            middleName: personalInformation ? personalInformation["middle-name"] : "",
            phone: personalInformation
                ? personalInformation["additional-phone"]
                    ? [personalInformation["primary-phone"], ...personalInformation["additional-phone"]]
                    : personalInformation["primary-phone"]
                    ? [personalInformation["primary-phone"]]
                    : [{ phone: "" }]
                : [{ phone: "" }],
            securityNumber: personalInformation ? personalInformation["ssn"] : formData.securityNumber,
            internationalSecurityNumber: personalInformation && personalInformation["monitoring-sin"] ? personalInformation["monitoring-sin"] : {},
            nationalIdentificationNumber: personalInformation && personalInformation["monitoring-nid"] ? personalInformation["monitoring-nid"] : {},
            businessCreditSafeNumber:
                personalInformation && personalInformation["business-credit-safe-number"] ? personalInformation["business-credit-safe-number"] : "",
            businessDUNSNumber: personalInformation && personalInformation["business-duns-number"] ? personalInformation["business-duns-number"] : "",
            businessFaxNumber: personalInformation && personalInformation["business-fax-number"] ? personalInformation["business-fax-number"] : "",
            businessName: personalInformation && personalInformation["business-name"] ? personalInformation["business-name"] : "",
            companyDomain: personalInformation && personalInformation["company-domain"] ? personalInformation["company-domain"] : "",
            businessEINNumber: personalInformation && personalInformation["business-ein-number"] ? personalInformation["business-ein-number"] : "",
            businessStateRegistryNumber:
                personalInformation && personalInformation["business-state-registry-number"] ? personalInformation["business-state-registry-number"] : "",
        });
        setisLoading(false);
    }, [props.monitoringData]);

    const [formData, setFormData] = useState({
        "date-of-birth": "",
        emails: [{ email: "" }],
        firstName: "",
        lastName: "",
        middleName: "",
        phone: [{ phone: "", code: "" }],
        securityNumber: "",
        "ezshield-id": "",
        "idf-user-id": "",
        internationalSecurityNumber: { sin: "" },
        nationalIdentificationNumber: { nid: "" },
        businessCreditSafeNumber: "",
        businessDUNSNumber: "",
        businessFaxNumber: "",
        businessName: "",
        companyDomain: "",
        businessEINNumber: "",
        businessStateRegistryNumber: "",
    });

    /***handling the email field***/
    return (
        <div className={`box offset-padding ${isLoading && "loading"}`}>
            <div className="box-header">
                <div className="box-title-container">
                    <div className="box-title-icon" aria-hidden="true">
                        <em className="las la-user"></em>
                    </div>
                    <div className="box-title-text has-actions">
                        <h2 className="box-title">{tLang("identityVault.monitoredInformation.businessInfoWidget.title")}</h2>
                    </div>
                </div>
                <div className="box-description">
                    <p> {tLang("identityVault.monitoredInformation.businessInfoWidget.message")}</p>
                </div>
                {!personalInfo && (
                    <div className="box-actions">
                        <button
                            type="button"
                            className="btn-default btn-grey-dot"
                            id="monitored-info-personal-information"
                            onClick={() => {
                                setPersonalInfo(true);
                                window.addToDataLayer({ event: "Edit Business Information" });
                            }}
                        >
                            <span className="btn-text">
                                {tLang("identityVault.monitoredInformation.businessInfoWidget.editLinkText")}
                                <span className="sr-only">{tLang("identityVault.monitoredInformation.businessInfoWidget.title")}</span>
                            </span>
                            <span className="btn-icon">
                                <em className="las la-pen"></em>
                            </span>
                        </button>
                    </div>
                )}
            </div>
            <div className="box-content">
                {!personalInfo ? (
                    <div role="grid" className="data-grid " id="monitored-info-personal-information-grid" aria-hidden="false">
                        <div role="row" className="data-row row">
                            <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                <div className="data-label" id="label-business-name-display">
                                    {tLang("identityVault.monitoredInformation.businessInfoWidget.label.businessName")}
                                </div>
                            </div>
                            <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-business-name-display">
                                <div className="data-value">
                                    {formData.businessName ? formData.businessName : "-"}
                                </div>
                            </div>
                        </div>

                        {formData.emails && formData.emails.length > 0 ? (
                            formData!.emails!.map((email: any, index: number) => {
                                return (
                                    <div role="row" key={index} className="data-row row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`label-email-display-${index + 1}`}>
                                                {index === 0 && tLang("identityVault.monitoredInformation.businessInfoWidget.label.email")}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby={`label-email-display-${index + 1}`}>
                                            <div className="data-value">
                                                {email && email.email && emailMasking(email.email)}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div>
                                <div role="row" className="data-row row">
                                    <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                        <div className="data-label" id="label-email-display">
                                            {tLang("identityVault.monitoredInformation.businessInfoWidget.label.email")}
                                        </div>
                                    </div>
                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-email-display">
                                        <div className="data-value">
                                            -
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                        {formData.phone && formData.phone.length > 0 ? (
                            formData.phone.map((phone: any, index: number) => {
                                if (phone && !!phone.phone) phone.phone = phone.phone.replace(/[^0-9+]/g, "");
                                return (
                                    <div key={index} role="row" className="data-row row">
                                        <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                            <div className="data-label" id={`label-phone-display-${index + 1}`}>
                                                {index === 0 && tLang("identityVault.monitoredInformation.businessInfoWidget.label.phone")}
                                            </div>
                                        </div>
                                        <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby={`label-phone-display-${index + 1}`}>
                                            <div className="data-value">
                                                {phone.phone &&
                                                    `${"*".repeat(phone.phone.substr(0, phone.phone.length - 4).length)}${phone.phone.substr(
                                                        phone.phone.length - 4
                                                    )}`}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        ) : (
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-phone-display">
                                        {tLang("identityVault.monitoredInformation.businessInfoWidget.label.phone")}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-phone-display">
                                    <div className="data-value">
                                        -
                                    </div>
                                </div>
                            </div>
                        )}

                        {creditProvider === "CREDITSAFE" && (
                            <div role="row" className="data-row row">
                                <div role="gridcell" className="col-xs-12 col-sm-4 col-no-gutter">
                                    <div className="data-label" id="label-ein-display">
                                        {tLang("identityVault.monitoredInformation.businessInfoWidget.label.ein")}
                                    </div>
                                </div>
                                <div role="gridcell" className="col-xs-12 col-sm-8 col-no-gutter" aria-labelledby="label-ein-display">
                                    <div className="data-value">
                                        {formData.businessEINNumber
                                            ? "*".repeat(formData.businessEINNumber.substr(0, formData.businessEINNumber.length - 4).length) +
                                              formData.businessEINNumber.substr(formData.businessEINNumber.length - 4)
                                            : "-"}
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                ) : (
                    <BusinessInfoForm
                        refreshDataCallback={ensureDataFetched}
                        setStatus={setPersonalInfo}
                        addressInfo={addressInfo}
                        status={personalInfo}
                        formData={formData}
                        setFormData={setFormData}
                    />
                )}
            </div>
        </div>
    );
};

export default BusinessInfo;
